import { render, staticRenderFns } from "./RedemptionsAdmin.vue?vue&type=template&id=78a9dd71&scoped=true"
import script from "./RedemptionsAdmin.vue?vue&type=script&lang=js"
export * from "./RedemptionsAdmin.vue?vue&type=script&lang=js"
import style0 from "./RedemptionsAdmin.vue?vue&type=style&index=0&id=78a9dd71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a9dd71",
  null
  
)

export default component.exports